<template>
  <div class="role">
    <el-row class="drink-title">
      <el-col :span="6">
        <span class="h3">{{$t('jiao_se_pei_zhi')}}</span>
      </el-col>
      <el-col :span="18">
        <el-form label-width="auto" :inline="true" size="mini">
          <el-col :span="6" :offset="18">
            <el-button size="mini" type="primary" @click="handleRoleCreate">{{$t('xin_zeng_jiao_se')}}</el-button>
          </el-col>

        </el-form>
      </el-col>
    </el-row>
    <el-table :data="roles" class="pay-container">
      <el-table-column :label="$t('jiao_se_ming_cheng')" align="center" prop="name"></el-table-column>
      <el-table-column :label="$t('mo_ren_jiao_se')" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isDefault"
                     :disabled="scope.row.moduleName == '' || scope.row.isDefault==1"
                     @change="handleChangeRole(scope.row.uuid)"></el-switch>
        </template>
      </el-table-column>

      <el-table-column :label="$t('xiang_guan_mo_kuai')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.moduleName">{{scope.row.moduleName}}</span>
          <span v-else>{{$t('quan_bu_mo_kuai')}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cao_zuo')" align="center" min-width="160px">
        <template slot-scope="scope">
          <p class="role-operate">
            <span  v-show="scope.row.moduleName"
                   @click="handleLoadCloseRight(scope.row)"
                   class="user-edit" >{{$t('guan_bi_quan_xian')}}</span>
            <span class="user-edit" v-show="scope.row.moduleName"
            @click="handleRoleUpdate(scope.row)">{{$t('bian_ji_xin_xi')}}</span>
            <span class="user-edit" @click="handleRoleList(scope.row)">{{$t('cha_kan_cheng_yuan')}}</span>
            <span class="user-edit" @click="handleUnbindUserList(scope.row)">{{$t('bang_ding_cheng_yuan')}}</span>
            <span v-show="scope.row.moduleName" class="user-delete" @click="handleDelete(scope.row)">{{$t('shan_chu')}}</span>
          </p>

        </template>
      </el-table-column>
    </el-table>

    <c-dialog class="dialog" :visible.sync="rightCloseVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              :title="$t('guan_bi_quan_xian')">
     <div class="right">
       <div style="margin: auto;width: 520px">
         <el-transfer
           :titles="[$t('wei_guan_bi_quan_xian'), $t('yi_guan_bi_quan_xian')]"
           filterable
           :filter-method="filterMethod"
           :filter-placeholder="$t('qing_shu_ru_guan_bi_quan_xian_ming_cheng')"
           v-model="roleButtons.choice"
           :props="{key:'uuid', label:'name'}"
           :data="roleButtons.other">
         </el-transfer>
       </div>

       <p style="margin-top: 24px;text-align: center">
         <el-button @click="rightCloseVisible=false" >{{$t('qu_xiao')}}</el-button>
         <el-button @click="handleUpdateRoleButton" type="primary">{{$t('que_ding')}}</el-button>
       </p>
     </div>
    </c-dialog>

    <c-dialog class="dialog" :visible.sync="roleCreateVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              :title="$t('jiao_se_xin_xi')">
      <el-button slot="title" size="mini" type="primary" @click="handleCreateRole">{{$t('bao_cun')}}</el-button>

      <el-form label-width="auto">
        <el-form-item :label="$t('jiao_se_ming_cheng')">
          <el-input v-model="role.name"></el-input>
        </el-form-item>

        <el-form-item :label="$t('jiao_se_mo_kuai')">
          <div class="module-container">
            <div class="module-sort-item" v-for="(moduleSort, key) in moduleSorts" :key="key">
              <p class="module-sort-item-title">{{moduleSortName[moduleSort.uuid]}}</p>

              <div class="module-sort-item-container">
                <el-checkbox v-for="module in moduleSort.modules" :key="module.uuid"
                             :label="module.name" v-model="module.isCheck">
                  {{moduleSort.moduleMap[module.uuid]}}
                </el-checkbox>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

    </c-dialog>


    <c-dialog :visible.sync="roleUserVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              title="已绑定角色用户">
      <users ref="bindUser"></users>
    </c-dialog>

    <c-dialog :visible.sync="roleUnbindUserVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              title="未绑定角色用户">
      <el-button slot="title" size="mini" type="primary" @click="handleUpdateUserRole">{{$t('bao_cun')}}</el-button>

      <unbind-user ref="unbindUser"></unbind-user>
    </c-dialog>

  </div>
</template>

<script>
  import CDialog from '@/components/Dialog'
  import Users from './users'
  import UnbindUser from '@/components/UnbindUser'
  import {
    roleCreate,
    roleList,
    roleSetDefault,
    roleUpdate,
    roleBindUser,
    roleDelete,
    roleModules,
    roleHiddenButtons,
    roleHiddenButtonUpdate,
  } from '@/api/account/role'

  export default {
    name: '',
    components: {
      UnbindUser,
      CDialog,
      Users
    },
    activated: function () {

      this.loadRole()
    },
    data: function () {
      return {
        roles: [],
        roleButtons:{
          roleUuid: '',
          choice:[],
          other:[],
        },
        pagination: {
          start: 0,
          curPage: 1,
          limit: 8,
          total: 0,
          name: ''
        },
        role: {
          uuid: '',
          name: '',
          moduleUuid: [],
          moduleName: ''
        },
        moduleSorts: [],
        roleCreateVisible: false,
        roleUserVisible: false,
        roleUnbindUserVisible: false,
        rightCloseVisible: false,
        roleUuid: '',
        moduleSortName:{},

      }
    },
    filters: {},
    methods: {
      loadRole() {

        let t = {
          '首页': this.$t('t_500865ef2001000') ,
          '对比分析': this.$t('t_500985da1401000') ,
          '研发管理': this.$t('t_50083b154801000') ,
          '设备管理': this.$t('t_50084945b801000') ,
          '经销商管理': this.$t('t_50084a5d9401000') ,
          '系统设置': this.$t('t_50084b33a001000') ,
          '经销商首页': this.$t('t_50085d8eb001000') ,
          '成员管理': this.$t('t_500867b84801000') ,
          '订单管理': this.$t('t_50086895bc01000') ,
          '设备管理': this.$t('t_500869810c01000') ,
          '系统设置': this.$t('t_50088bc26001000') ,
          '组织架构': this.$t('t_50086cbb4c01000') ,
          '成员列表': this.$t('t_50086f4e0001000') ,
          '订单分析': this.$t('t_50087496d401000') ,
          '制作清单': this.$t('t_500876e1a401000') ,
          '设备列表': this.$t('t_50087b146c01000') ,
          '屏显管理': this.$t('t_50087d152001000') ,
          '饮品管理': this.$t('t_50087ea47001000') ,
          '维护设置': this.$t('t_500880105001000') ,
          '费用清单': this.$t('t_5008847d6c01000') ,
          '数据分析': this.$t('t_500885da1401000') ,
          '支付设置': this.$t('t_50088a319801000') ,
          '角色配置': this.$t('t_5008f30d3401000') ,
          '告警列表': this.$t('t_55be408fd001000') ,
          '异常告警': this.$t('t_55d2b4167c01000') ,
          '数据导出': this.$t('t_563a1a536801000') ,
        }
        roleList().then(res => {
          this.roles = res.data || []
          this.roles.map(role => {
            role.isDefault = role.isDefault === 1
            if (role.moduleName) {
              let moduleNames = role.moduleName.split(",") || []
              let mn = []
              moduleNames.forEach(m => {
                mn.push(t[m])
              })
              role.moduleName = mn.join(', ')
            }
          })
        })
        roleModules().then(res => {
          this.moduleSorts = res.data || []

          let map = {}
          this.moduleSorts.forEach((ms) => {
            map[ms.uuid]= this.$t('t_'+ms.uuid)
            let _map = {}
            ms.modules =  ms.modules || []
            ms.modules.forEach((m) => {
              _map[m.uuid] = this.$t('t_'+m.uuid)
            })
            ms.moduleMap = _map
          })

          this.moduleSortName = map
        })
      },

      filterMethod(query, item) {
        return item.name.indexOf(query) > -1;
      },


      handleRoleCreate() {
        this.role = {
          uuid: '',
          name: '',
          moduleUuid: [],
          moduleName: ''
        }
        this.moduleSorts.map((item, index) => {
          item.modules.map((module, key) => {
            this.$set(this.moduleSorts[index].modules[key], 'isCheck', false);
          })
        })
        this.roleCreateVisible = true
      },

      handleUpdateRoleButton(){
        if (this.roleButtons.choice.length === 0) {
          this.rightCloseVisible = false
          return
        }

        let data = {
          uuid: this.roleButtons.roleUuid,
          buttonUuid:this.roleButtons.choice
        }
        roleHiddenButtonUpdate(data).then(() => {
          this.$message.success('更新成功')
          this.rightCloseVisible = false
        })
      },

      handleRoleUpdate(role) {
        this.role.name = role.name
        this.role.uuid = role.uuid
        this.moduleSorts.map((item, index) => {
          item.modules.map((module, key) => {
            this.$set(this.moduleSorts[index].modules[key], 'isCheck', role.moduleName.indexOf(module.name) >= 0);
          })
        })
        this.roleCreateVisible = true
      },

      handleChangeRole(uuid) {
        roleSetDefault({uuid: uuid}).then(() => {
          this.roles.map(role => {
            role.isDefault = role.uuid === uuid
          })
          this.$message.success('设置成功')
        })
      },

      handleRoleList(role) {
        this.roleUserVisible = true
        this.$nextTick(() => {
          this.$refs.bindUser.loadUser(role.uuid)
        })

      },

      handleUnbindUserList(role) {
        this.roleUnbindUserVisible = true
        this.roleUuid = role.uuid
        this.$nextTick(() => {
          this.$refs.unbindUser.loadUser(role.uuid)
        })

      },

      handleUpdateUserRole() {
        let userUuid = this.$refs.unbindUser.userAllocate() || []
        if (userUuid.length === 0) {
          this.$message.warning('请选取需要分配的成员')
          return
        }

        roleBindUser({uuid: this.roleUuid, userUuid: userUuid}).then(res => {
          this.$message.success('设置成功')
          this.roleUnbindUserVisible = false
        })
      },

      handleLoadCloseRight(data) {
        this.roleButtons.roleUuid = data.uuid
        roleHiddenButtons({uuid: data.uuid}).then(res => {
          if (res.code === 0) {
            let other = res.data.other || []
            let id = []
            let btns = res.data.choice || []
            btns.forEach(item => {
              id.push(item.uuid)
              other.push(item)
            })
            this.roleButtons.other = other
            this.roleButtons.choice = id
            this.rightCloseVisible = true
          }
        })
      },

      handleCreateRole() {
        if (!this.role.name) {
          this.$message.warning('请输入角色名称')
          return
        }
        let moduleName = []

        this.moduleSorts.map(item => {
          item.modules.map(module => {
            if (module.isCheck) {
              this.role.moduleUuid.push(module.uuid)
              moduleName.push(module.name)
            }
            module.isCheck = false
          })
        })

        if (!moduleName.length) {
          this.$message.warning('请选取需要配置权限')
          return
        }

        this.role.moduleName = moduleName.join(',')

        if (this.role.uuid !== '') {
          roleUpdate(this.role).then(() => {
            this.$message.success('新增成功')
            this.roleCreateVisible = false
            this.role = {
              uuid: '',
              name: '',
              moduleUuid: [],
              moduleName: ''
            }
            this.loadRole()
          })
        } else {
          roleCreate(this.role).then(() => {
            this.$message.success('新增成功')
            this.roleCreateVisible = false
            this.role = {
              uuid: '',
              name: '',
              moduleUuid: [],
              moduleName: ''
            }
            this.loadRole()
          })

        }

      },

      handleDelete(role) {
        this.$confirm('删除角色将导致用户无法正常使用系统功能，是否继续删除', this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          roleDelete({uuid: role.uuid}).then(() => {
            this.$message.success('删除成功')
            this.loadRole()
          })
        }).catch(() => {

        })
      }


    },
  }
</script>

<style lang="scss">
  .right {
    padding-top: 32px;

    .el-transfer {
      .el-transfer-panel {
        background-color: transparent;
        .el-transfer-panel__header {
          background-color: transparent;
          .el-checkbox__label {
            color: $f_color;
            font-size: .8rem;
          }
        }

        .el-transfer-panel__body {
          .el-transfer-panel__filter {
            .el-input__inner {
              border-radius: 0;
            }
          }

          .el-checkbox__label {
            color: $f_sec_color;
          }
        }
      }
    }
  }
  .role {
    padding: $padding $t-padding;

    .module-container {
      padding-top: $padding;

      .module-sort-item {
        margin-bottom: $t-padding;

        .module-sort-item-title {
          margin-bottom: $padding;
          color: $f_sec_color;
          font-size: 1rem;
        }

        .el-checkbox__inner {
          background-color: transparent;
        }
      }
    }

    .role-operate {
      span {
        display: inline-block;
        margin-right: $padding;
        cursor: pointer;
      }

      .user-edit {
        color: $btn_color;
      }

      .user-delete {
        color: $btn_sec_color;
      }
    }

  }
</style>
